import { render, staticRenderFns } from "./fbsignature.vue?vue&type=template&id=90f8aa4a&scoped=true&"
import script from "./fbsignature.vue?vue&type=script&lang=js&"
export * from "./fbsignature.vue?vue&type=script&lang=js&"
import style0 from "./fbsignature.vue?vue&type=style&index=0&id=90f8aa4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f8aa4a",
  null
  
)

export default component.exports